import { createWebSocketConnection } from "@/webSocketFactory";

import { nextCargoApi } from "../../baseApi";
import { queueApi } from "../queue/queue.api";
import { AttendanceCountUpdated, Called } from "./socket.types";

export const socketTvApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    driverCalled: build.query<Called, void>({
      queryFn: () => ({ data: { driverCalled: null, type: null, content: null } }),
      onCacheEntryAdded: async (_, { dispatch, cacheDataLoaded, updateCachedData, cacheEntryRemoved }) => {
        const socket = createWebSocketConnection();

        await cacheDataLoaded;

        socket.on("checkInCallResponse", (data: Called) => {
          console.log("📡 Dados recebidos do socket:", data);

          dispatch(queueApi.util.invalidateTags(["QueueDelayStatus"]));
          updateCachedData((draft) => {
            Object.assign(draft, data);
          });
        });

        socket.connect();
        await cacheEntryRemoved;
        socket.disconnect();
      }
    }),
    attendanceCountUpdated: build.query<AttendanceCountUpdated, void>({
      queryFn: () => ({ data: { type: null, content: null, inAttendance: 0 } }),
      onCacheEntryAdded: async (_, { dispatch, cacheDataLoaded, updateCachedData, cacheEntryRemoved }) => {
        const socket = createWebSocketConnection();

        await cacheDataLoaded;

        socket.on("countInAttendanceResponse", (data: AttendanceCountUpdated) => {
          console.log("📡 Dados recebidos do socket:", data);

          dispatch(queueApi.util.invalidateTags(["QueueDelayStatus"]));
          updateCachedData((draft) => {
            Object.assign(draft, data);
          });
        });

        socket.connect();
        await cacheEntryRemoved;
        socket.disconnect();
      }
    })
  })
});

socketTvApi.enhanceEndpoints({
  endpoints: {
    driverCalled: {
      providesTags: ["DriverCalled"]
    },
    attendanceCountUpdated: {
      providesTags: ["AttendanceCountUpdated"]
    }
  }
});
